import React from 'react';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';

/* import defualtPlayerImg from "./../../graphics/elements/iconGroupPic.svg";
 import notCaptainBadge from "./../../graphics/elements/notCaptainBadge.svg"; */
import captainBadge from './../../graphics/elements/captainBadge.svg';
import HeaderTopic from '../../partials/HeaderTopic';
import FooterMenu from '../../partials/FooterMenu';
import BasicButtons from '../../partials/BasicButtons';
import PlayerActionButtons from './PlayerActionButtons/PlayerActionButtons';
import * as func from '../../utils/funcs';
import { getGroupsList } from '../../api/getGroupsList';

import styles from './PlayerProfile.module.css';
import iconProfile from './../../graphics/elements/profile_photo.svg';
import { getUserPlayerInfo } from '../../api/getUserPlayerInfo';
import PrimaryButton from '../../partials/PrimaryButton';


function PlayerProfile(props) {
  const { user, setUser, league, teams, setTeams, refreshStates } = props;
  const { leagueId } = useParams();
  const history = useHistory();

  const isReferee = (user?.refereed_league_ids?.length ?? 0) > 0;
  const hasMoreThanOneLeague = (user?.refereed_league_ids?.length ?? 0) > 1;
  let role = '';

  if (isReferee) {
    role = 'שופט';
  } else if (user.is_leagues_manager) {
    role = 'רכז'
  }

  const [player, setPlayer] = React.useState(user?.player ? func.userToPlayer(user) :
    null);


  React.useEffect(() => {
    getUserPlayerInfo().then((data) => {
      if (data && data.player) {
        setPlayer(func.userToPlayer(data));
      }
    });
  }, []);

  React.useEffect(() => {
    if (teams.length === 0 && leagueId !== 'undefined') {
      getGroupsList(leagueId).then((data) => {
        setTeams(data);
      });
    }
  }, [leagueId, setTeams, teams]);

  const textGrade = (numGrade) => {
    if (numGrade === 7) return 'ז\''; else if (numGrade ===
      8) return 'ח\''; else if (numGrade === 9) return 'ט\''; else if (numGrade ===
      10) return 'י\''; else if (numGrade === 11) return 'יא\''; else if (numGrade ===
      12) return 'יב\''; else return 'לא מוגדרת';
  };

  return (<div className={styles.playerInfo}>
      <HeaderTopic
        topic={leagueId !== 'undefined' ? 'ליגת ' + league.name : 'ליגות החלוץ'}
      />
      <BasicButtons user={user} refreshStates={refreshStates} />
      <FooterMenu setActive="league" />

      {player && (<PlayerActionButtons
          user={user}
          setUser={setUser}
          player={player}
          leagueId={leagueId}
          setTeams={setTeams}
          refreshStates={refreshStates}
        />)}

      {isReferee && hasMoreThanOneLeague &&
        (<div className={styles.switchLeagueBtn} onClick={() => history.push('/leagues')}>
            החלפת ליגה
          </div>)}

      {player && (<>
          <div className={styles.upperInfo}>
            <img
              src={player.profile_pic !== null ? player.profile_pic : iconProfile}
              alt="תמונת השחקן"
            />
            <div>
              <h2>{player.user.full_name}
                {role && <span  > ({role})</span>}
              </h2>

              <h3>{player.sentence}</h3>
            </div>
            {player.status === 'captain' &&
              (<img className={styles.badge} src={captainBadge} alt="קפטן" />)}
          </div>
          <div className={styles.mainInfo}>
            <span>
              {player.team !== null && teams.length > 0 ?
                teams.filter((team) => team.id === player.team)[0]?.name :
                'טרם נכנס לקבוצה'}
            </span>
            <span>שכבה {textGrade(player.grade)}</span>
            <span>ביהס {player.school}</span>
            <span>{league && league.city_name}</span>
            <span>טלפון: {player.phone_number}</span>
            <span>הליגה: {league !== undefined ? league.name : 'טרם הוגדר'}</span>
            <span>שערים: {player.goals_count}</span>
            <span>בישולים: {player.assists_count}</span>
          </div>
        </>)}

      {!player && isReferee && (<div className={styles.mainInfo}>
          <span>{user.full_name}</span>
          <span>טלפון: {user.phone_number}</span>

          <PrimaryButton
            text="התנתקות"
            onClick={refreshStates}
            size="medium"
          />

        </div>)}
    </div>);
}

export default PlayerProfile;
